import React, { useContext, useEffect, useState, useMemo } from 'react';
import styles from './ProfileSubscriptionStatus.module.css';
import { fetchPaymentHistory, fetchSubscriptionUrl } from '../../../services';
import { dataContext } from '../../../App';
import { formatDateTime } from '../ReferralHistory/dateFormatter';

const ProfileSubscriptionStatus = ({
  isSubscribe,
  isSubscribeMemoryMatch,
  isSubscribeSpellingBee,
  setShowLoginModal,
  setShowOtpModal,
  setShowRefundModal
}) => {
  const { token, playerData } = useContext(dataContext);
  const [activeTab, setActiveTab] = useState('active');
  const [wordlyPayment, setWordlyPayment] = useState({});
  const [spellingBeePayment, setSpellingBeePayment] = useState({});
  const [memoryMatchPayment, setMemoryMatchPayment] = useState({});

  useEffect(() => {
    fetchPaymentHistory(token).then((res) => {
      // Helper to get latest payment by service_type
      function getLatestPayment(serviceType) {
        const filtered = res.filter(
          (item) => item.serviceType === serviceType
        );
        if (filtered.length === 0) return {};
        // Sort by payment_date descending
        filtered.sort(
          (a, b) => new Date(b.paymentDate) - new Date(a.paymentDate)
        );
        return filtered[0];
      }

      setWordlyPayment(getLatestPayment("Wordly"));
      setSpellingBeePayment(getLatestPayment("SpellingBee"));
      setMemoryMatchPayment(getLatestPayment("MemoryMatch"));
    });
  }, [token]);

  function handleSubscriptionClick(service_type) {
    if (!playerData?.id) {
      setShowLoginModal(true);
      return;
    }
    fetchSubscriptionUrl(token, service_type)
      .then((res) => {
        setShowOtpModal(true);
      });
  }

  function handleUnSubscriptionClick(service_type) {
    sessionStorage.setItem('unsubsServiceType', service_type);
    setShowRefundModal(true);
  }

  // Create subscription data array
  const subscriptionData = useMemo(() => [
    {
      id: 'wordly',
      type: 'Wordly',
      title: 'WORDLY সাবস্ক্রিপশন',
      background: '#12793C',
      isSubscribed: isSubscribe,
      payment: wordlyPayment,
      feature: 'প্রতিদিন ২ রাউন্ড WORDLY.'
    },
    {
      id: 'memoryMatch',
      type: 'MemoryMatch',
      title: 'MEMORY MATCH সাবস্ক্রিপশন',
      background: '#ff6646',
      isSubscribed: isSubscribeMemoryMatch,
      payment: memoryMatchPayment,
      feature: 'আনলিমিটেড Memory Match রাউন্ড.'
    },
    {
      id: 'spellingBee',
      type: 'SpellingBee',
      title: 'SPELLING BEE সাবস্ক্রিপশন',
      background: '#8700d9',
      isSubscribed: isSubscribeSpellingBee,
      payment: spellingBeePayment,
      feature: 'প্রতিদিন ২ রাউন্ড Spelling Bee.'
    }
  ], [
    isSubscribe, isSubscribeMemoryMatch, isSubscribeSpellingBee,
    wordlyPayment, spellingBeePayment, memoryMatchPayment
  ]);

  // Filter active subscriptions
  const activeSubscriptions = useMemo(() =>
    subscriptionData.filter(sub => sub.isSubscribed),
  [subscriptionData]);

  // Filter unsubscribed packages for the 'অন্যান্য প্যাকেজ' tab
  const unsubscribedPackages = useMemo(() =>
    subscriptionData.filter(sub => !sub.isSubscribed),
  [subscriptionData]);

  return (
    <div className={styles.subscriptionContainer}>
      <h2 className={styles.title}>সাবস্ক্রিপশন</h2>

      <div className={styles.tabContainer}>
        <div
          className={`${styles.tab} ${activeTab === 'active' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('active')}
        >
          একটিভ সাবস্ক্রিপশন
        </div>
        <div
          className={`${styles.tab} ${activeTab === 'all' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('all')}
        >
          অন্যান্য প্যাকেজ
        </div>
      </div>

      {activeTab === 'active' && (
        <>
          {activeSubscriptions.length === 0 ? (
            <div className={styles.emptyMessage}>
              বর্তমানে কোনো সাবস্ক্রিপশন বা প্যাকেজ একটিভ নেই।
            </div>
          ) : (
            activeSubscriptions.map((subscription, index) => (
              <div
                key={subscription.id}
                className={styles.subscriptionBox}
                style={index === activeSubscriptions.length - 1 ? {marginBottom: '0px'} : {}}
              >
                <div className={styles.header}>
                  <span className={styles.type} style={{background: subscription.background}}>
                    {subscription.title}
                  </span>
                  <span className={styles.badge}>সাবস্ক্রাইবড</span>
                </div>

                <div className={styles.price}>
                  <span className={styles.amount}>৳৩০</span>
                  <span className={styles.duration}>ট্যাক্স সহ ৭ দিনের জন্য</span>
                  <br></br><span>**অটো রিনিউয়াল প্রযোজ্য</span>
                  {subscription.payment?.paymentDate && (
                    <>
                      <br /><span style={{fontSize:'14px'}}>Payment Date: {formatDateTime(subscription.payment.paymentDate)}</span>
                      <br /><span style={{fontSize:'14px'}}>Next Payment Date: {formatDateTime(subscription.payment.nextPaymentDate)}</span>
                    </>
                  )}
                </div>

                <div className={styles.features}>
                  <div className={styles.feature}>{subscription.feature}</div>
                </div>

                <button
                  className={styles.unsubscribeButton}
                  onClick={() => handleUnSubscriptionClick(subscription.type)}
                >
                  আনসাবস্ক্রাইব করুন
                </button>
              </div>
            ))
          )}
        </>
      )}

      {activeTab === 'all' && (
        unsubscribedPackages.map((subscription, index) => (
          <div
            key={subscription.id}
            className={styles.subscriptionBox}
            style={index === unsubscribedPackages.length - 1 ? {marginBottom: '0px'} : {}}
          >
            <div className={styles.header}>
              <span className={styles.type} style={{background: subscription.background}}>
                {subscription.title}
              </span>
            </div>

            <div className={styles.price}>
              <span className={styles.amount}>৳৩০</span>
              <span className={styles.duration}>ট্যাক্স সহ ৭ দিনের জন্য</span>
              <br></br><span>**অটো রিনিউয়াল প্রযোজ্য</span>
            </div>

            <div className={styles.features}>
              <div className={styles.feature}>{subscription.feature}</div>
            </div>

            <button
              className={styles.subscribeButton}
              onClick={() => handleSubscriptionClick(subscription.type)}
            >
              সাবস্ক্রাইব করুন
            </button>
          </div>
        ))
      )}
    </div>
  );
};

export default ProfileSubscriptionStatus;